import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/site/Primitives";
import { OUR_WORK } from "@/data/content";

// Three-photo preview strip linking to the full Our Work gallery.
// Picks one photo each from three different categories for variety.
const picks = ["Oven & Kitchen Deep Cleaning", "Bathroom Cleaning", "Commercial Cleaning"];
const TEASER = picks
  .map((c) => OUR_WORK.find((i) => i.category === c))
  .filter(Boolean)
  .slice(0, 3);

export const OurWorkTeaser = () => (
  <section data-testid="ourwork-teaser" className="mx-auto max-w-[1400px] px-6 md:px-10 py-16 md:py-20">
    <Reveal>
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-8">
        <div>
          <span className="overline">Our Work</span>
          <h2 className="font-display font-light text-3xl sm:text-4xl text-white tracking-tight mt-3">
            More real projects, <span className="gold-gradient italic">real results.</span>
          </h2>
        </div>
        <Link
          to="/our-work"
          data-testid="teaser-gallery-link"
          className="group inline-flex items-center gap-2 rounded-full border border-gold/50 text-gold text-sm font-medium px-6 py-3 hover:bg-gold hover:text-black transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-gold/60 shrink-0"
        >
          View Full Gallery
          <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform duration-300" />
        </Link>
      </div>
    </Reveal>

    <div className="grid gap-5 sm:grid-cols-3">
      {TEASER.map((it, i) => (
        <Reveal key={it.src} delay={i * 0.08}>
          <Link
            to="/our-work"
            data-testid={`teaser-item-${i}`}
            className="group block border border-white/5 bg-[#121212] overflow-hidden hover:border-gold transition-colors duration-300"
          >
            <div className="relative aspect-[4/3] overflow-hidden bg-black">
              <img
                src={it.src}
                alt={`${it.category} project by Perfect Touch`}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <div className="p-4 flex items-center justify-between gap-3">
              <span className="overline">{it.category}</span>
              <ArrowRight size={14} className="text-gold shrink-0 group-hover:translate-x-1 transition-transform duration-300" />
            </div>
          </Link>
        </Reveal>
      ))}
    </div>
  </section>
);
